/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowEatOutTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowEatOut,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Time to eat out!",
    "Feast Mode: Activated!",
    "Let’s Get Our Forks Dirty!",
    "Chow Down Showdown!",
  ],
  title: "Dining Out",
  description:
    "Plan a memorable night out with friends at your favorite restaurant.",
  longDescription:
    "Make planning your dinner outings easy and fun. Choose the best date, pick the perfect restaurant, and ensure everyone is in sync. Enjoy a great meal together without the stress of organizing — it’s all in one place.",
  emoji: "🍝",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Calendar,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Dining Out",
          emoji: "🍝",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we eat?",
          settings: { groupDays: false },
          emoji: "📅",
          completeAction: {
            question: "Find a place as well?",
            description:
              "We can help you coordinate where the whole group wants to go this time, by adding options and voting for the best one.",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "Where should we eat?",
                emoji: "🌎",
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Awesome, It's Set!",
    outroDescription:
      "You’ve nailed down all the details! Enjoy your meal and have a fantastic time together!",
  },
};
